import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL, camelizeResponse } from 'shared';
const baseQuery = fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: async (headers, { getState }) => {
        const state = getState();
        const receiptToken = state?.root?.creditPortal?.flexFinalize?.authorizationToken;
        receiptToken &&
            headers.set('Authorization', process.env.NODE_ENV === 'test' ? '' : receiptToken);
    },
});
const baseQueryWithCamelize = camelizeResponse(baseQuery);
export const api = createApi({
    reducerPath: 'servicingApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: () => ({}),
    keepUnusedDataFor: 0,
});
